module.exports = __webpack_public_path__ + "img/2.ecc16ce7.png";